export default __webpack_public_path__ + "static/media/go_to_market_assets_preview.fa666212.png";